import React, { useState, useCallback } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './style.scss';
import GRNActions from '@Actions/grnActions';
import { Select } from 'antd';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import Helpers from '@Apis/helpers';
import PRZSelect from '../../../../../Common/UI/PRZSelect';

const GrnMail = ({
  user,
  selectedEntity,
  sendGRNMailToVendor,
  sendGRNMailToVendorLoading,
  callback,
}) => {
  const [toAddresses, setToAddresses] = useState([]);
  const [ccAddresses, setCcAddresses] = useState([]);
  const [invalidToAddress, setInvalidToAddress] = useState(false);
  const [invalidCcAddress, setInvalidCcAddress] = useState(false);
  const [formSubmitted, setFormSubmitted] = useState(false);

  const sendEmail = useCallback(() => {
    setFormSubmitted(true);

    const payload = {
      grn_id: selectedEntity?.grn_id,
      to_emails: toAddresses,
      cc_emails: ccAddresses,
      user_id: user?.user_id,
    };

    let allEmailsValid = true;

    for (let i = 0; i < toAddresses.length; i++) {
      if (!Helpers.validateEmail(toAddresses[i])) {
        allEmailsValid = false;
        setInvalidToAddress(true);
        break;
      }
    }

    for (let i = 0; i < ccAddresses.length; i++) {
      if (!Helpers.validateEmail(ccAddresses[i])) {
        allEmailsValid = false;
        setInvalidCcAddress(true);
        break;
      }
    }

    if (payload?.to_emails?.length && allEmailsValid && !invalidToAddress && !invalidCcAddress) {
      sendGRNMailToVendor(payload, callback);
    }
  }, [toAddresses, ccAddresses, invalidToAddress, invalidCcAddress, selectedEntity, sendGRNMailToVendor, callback]);

  return (
    <div className="po-mail__wrapper">
      <div className="ant-row">
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              Recipient Email Addresses
              <span style={{ color: 'red', marginLeft: '5px' }}>*</span>
            </label>
            <PRZSelect
              mode="tags"
              maxTagCount="responsive"
              value={toAddresses}
              filterOption={false}
              onChange={(value) => {
                for (let i = 0; i < toAddresses.length; i++) {
                  if (!Helpers.validateEmail(toAddresses[i])) {
                    setInvalidToAddress(false);
                    break;
                  }
                }
                setToAddresses(value);
              }}
              disabled={sendGRNMailToVendorLoading}
              showError={(formSubmitted && !toAddresses.length) || (formSubmitted && invalidToAddress)}
              errorName={formSubmitted && !toAddresses.length ? "/ enter at least one recipient" : "/ enter valid email addresses"}
              errorClassName="formError"
              placeholder=""
            />
          </div>
        </div>
        <div className="ant-col-md-24">
          <div className="orgInputContainer">
            <label className="orgFormLabel">
              CC Email Addresses
            </label>
            <PRZSelect
              mode="tags"
              value={ccAddresses}
              filterOption={false}
              maxTagCount="responsive"
              onChange={(value) => {
                for (let i = 0; i < ccAddresses.length; i++) {
                  if (!Helpers.validateEmail(ccAddresses[i])) {
                    setInvalidCcAddress(false);
                    break;
                  }
                }
                setCcAddresses(value);
              }}
              disabled={sendGRNMailToVendorLoading}
              showError={formSubmitted && invalidCcAddress}
              errorName="/ enter valid email addresses"
              errorClassName="formError"
              placeholder=""
            />
          </div>
        </div>
      </div>
      <div className="custom-drawer__footer">
        <div className="ant-col-md-6">
          <H3Button
            buttonType={defaultButtonTypes.BLUE_ROUNDED}
            text="Send Email"
            onClick={sendEmail}
            isLoading={sendGRNMailToVendorLoading}
            disabled={sendGRNMailToVendorLoading}
            style={{
              width: '160px',
              borderRadius: '5px',
              padding: '7px 0px',
              marginLeft: '0',
            }}
          />
        </div>
      </div>
    </div>
  );
};

const mapStateToProps = ({ GRNReducers, UserReducers }) => ({
  user: UserReducers.user,
  sendGRNMailToVendorLoading: GRNReducers.sendGRNMailToVendorLoading,
});

const mapDispatchToProps = (dispatch) => ({
  sendGRNMailToVendor: (payload, callback) => dispatch(GRNActions.sendGRNMailToVendor(payload, callback)),
});

GrnMail.propTypes = {
  selectedEntity: PropTypes.any,
  sendGRNMailToVendor: PropTypes.func,
  sendGRNMailToVendorLoading: PropTypes.bool,
  callback: PropTypes.func,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(GrnMail));
